import React, { createContext, useReducer } from 'react'

type Type = 'add' | 'remove' | 'prepend'

interface Message {
  key: string,
  style?: 'warning' | 'error',
  closeable?: boolean,
  content?: React.ReactNode

}

interface Action {
  type: Type
  message: Message
}

function reducer(state:Message[], action:Action) {
  const { type, message } = action

  switch (type) {
    case 'add': {
      return state.concat(message)
    }
    case 'prepend': {
      return [message].concat(state)
    }
    case 'remove': {
      return state.filter(m => {
        return m.key !== message.key
      })
    }
  }
}

export const MessagesState = createContext<Message[]>([])
export const MessagesDispatch = createContext<React.Dispatch<Action>>((action:Action) => {})

export const MessagesProvider = ({children}:any) => {
  const [state, dispatch] = useReducer(reducer, [])

  return (
    <MessagesState.Provider value={state}>
      <MessagesDispatch.Provider value={dispatch}>
        {children}
      </MessagesDispatch.Provider>
    </MessagesState.Provider>
  )
}